import { LoadingOutlined, UploadOutlined, DeleteOutlined, CloseOutlined } from "@ant-design/icons";
import { Button, Col, Form, Modal, Row, Typography, Upload } from "antd";
import Arrow from "assets/svg/arrow.svg";
import ivrPending from "assets/svg/ivrPending.svg";
import axios from "axios";
import {
  FormDrawer,
  buildInitialValues,
  buildValidationSchema,
} from "Components";
import { useTranslation } from "contexts/TranslationContext";
import { Formik } from "formik";
import useAuthHook from "hooks/useAuthHook";
import { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  useCreateNewAppMutation, useCreateNewTawaruqAppMutation, useCreateNewMurabahaAppMutation,
  useUpdateAppDetailsMutation, useUpdateAppDetailsV2Mutation,
} from "services/auth";
import BackButton from "shared/components/BackButton/BackButton";
import env from "shared/constants/env";
import routes, { appRoute } from "shared/constants/routes";
import * as Yup from "yup";

import schoolAlnubalaa from "assets/svg/schoolAlnubalaa.svg";
import schoolDigitalCulture from "assets/svg/schoolDigitalCulture.svg";
import schoolMinnha from "assets/svg/schoolMinnha.svg";

import schoolInterlude from "assets/svg/schoolInterlude.svg";
import schoolACHET from "assets/svg/schoolACHET.svg";
import schoolADCCC from "assets/svg/schoolADCCC.svg";
import schoolAlabda from "assets/svg/schoolAlabda.svg";
import schoolYa from "assets/svg/schoolYa.svg";
import alMashael from "assets/svg/alMashael.png";
import alMosa from "assets/svg/almosa.jpg";
import SalaryEligibilityGate from "components/SalaryEligibility/SalaryEligibilityGate";

const { Title, Text } = Typography;
const { Dragger } = Upload;

const SchoolProducts = () => {
    const { translate, language } = useTranslation();
    // V1 Mutations (kept for backwards compatibility)
    const [createNewApp, createNewAppStatus] = useCreateNewAppMutation();
    const [updateApplicationDetails, updateAppDetailsStatus] = useUpdateAppDetailsMutation();
    // V2 Mutations (active)
    const [createNewTawaruqApp, createNewTawaruqAppStatus] = useCreateNewTawaruqAppMutation();
    const [createNewMurabahaApp, createNewMurabahaAppStatus] = useCreateNewMurabahaAppMutation();
    const [updateApplicationDetailsV2, updateAppDetailsStatusV2] = useUpdateAppDetailsV2Mutation();
    const { getUser } = useAuthHook();
    const navigate = useNavigate();
    const { id } = useParams()
    const [uploadFile, setUploadFile] = useState(null);
    const [fileList, setFileList] = useState([]);
    const [isUploading, setIsUploading] = useState(false)

    // V2 Document selection tracking (before app creation)
    const [selectedBankStatement, setSelectedBankStatement] = useState(null);
    const [selectedPaySlip, setSelectedPaySlip] = useState(null);
    const [selectedOtherDocuments, setSelectedOtherDocuments] = useState(null);

    // V2 Individual file upload loading states (during upload phase)
    const [bankStatementUploading, setBankStatementUploading] = useState(false);
    const [paySlipUploading, setPaySlipUploading] = useState(false);
    const [otherDocumentsUploading, setOtherDocumentsUploading] = useState(false);

    const [tenureOptions, setTenureOptions] = useState([]);
    const [isCreating, setIsCreating] = useState(false);
    const [isIvrModalVisible, setIsIvrModalVisible] = useState(false);
    const [ivrApplicationId, setIvrApplicationId] = useState(null);
    const formikRef = useRef(null);

  // const { values } = useFormikContext()

  const isArabic = language?.code === "ar" ? true : false;

  let isLoading = createNewTawaruqAppStatus.isLoading || updateAppDetailsStatusV2.isLoading;

  // useEffect(() => {
  //     //check for Educational Products eligibility
  //     const user = JSON.parse(localStorage.getItem("@@TAMWEEL_USER"));
  //     if (user?.USER_ID && !user?.USER_ID?.toString().startsWith('1')) {
  //         toast.error('You are not eligible for Educational Products.');
  //         navigate(appRoute(routes.HOME));
  //     }
  // }, [id, navigate, translate]);

  const schoolDetails = [
    {
      id: 1,
      title: translate("HOME.SCHOOL_ALNUBALAA"),
      description: "HOME.AUTO_DESC",
      image: schoolAlnubalaa,
      subDescription: "EDUCATIONAL.SCHOOL_DESC_SUB",
    },
    {
      id: 2,
      title: translate("HOME.SCHOOL_DIGITAL_AL_MUNSIYAH"),
      description: "HOME.PERSONAL_DESC",
      image: schoolDigitalCulture,
      subDescription: "EDUCATIONAL.SCHOOL_DESC_SUB",
    },
    {
      id: 3,
      title: translate("HOME.SCHOOL_DIGITAL_IRQAH"),
      description: "HOME.PERSONAL_DESC",
      image: schoolDigitalCulture,
      subDescription: "EDUCATIONAL.SCHOOL_DESC_SUB",
    },
    {
      id: 4,
      title: translate("HOME.SCHOOL_MINNHA"),
      description: "HOME.PERSONAL_DESC",
      image: schoolMinnha,
      subDescription: "EDUCATIONAL.SCHOOL_DESC_SUB",
    },
    {
      id: 5,
      title: translate("HOME.SCHOOL_INTERLUDE"),
      description: "HOME.PERSONAL_DESC",
      image: schoolInterlude,
      subDescription: "EDUCATIONAL.SCHOOL_DESC_SUB",
    },
    {
      id: 6,
      title: translate("HOME.SCHOOL_ACHET"),
      description: "HOME.PERSONAL_DESC",
      image: schoolACHET,
      subDescription: "EDUCATIONAL.SCHOOL_DESC_SUB",
    },
    {
      id: 7,
      title: translate("HOME.SCHOOL_ADCCC"),
      description: "HOME.PERSONAL_DESC",
      image: schoolADCCC,
      subDescription: "EDUCATIONAL.SCHOOL_DESC_SUB",
    },
    {
      id: 8,
      title: translate("HOME.SCHOOL_SADA_ABDA"),
      description: "HOME.PERSONAL_DESC",
      image: schoolAlabda,
      route: 8,
    },
    {
      id: 9,
      title: translate("HOME.SCHOOL_YASCHOOLS"),
      description: "HOME.PERSONAL_DESC",
      image: schoolYa,
      subDescription: "EDUCATIONAL.SCHOOL_DESC_SUB",
    },
    {
      id: 10,
      title: translate("HOME.SCHOOL_AL_MASHAEL"),
      description: "HOME.PERSONAL_DESC",
      image: alMashael,
      subDescription: "EDUCATIONAL.SCHOOL_DESC_SUB",
    },
    {
      id: 11,
      title: translate("HOME.SCHOOL_AL_MASHAEL"),
      description: "HOME.PERSONAL_DESC",
      image: alMosa,
      subDescription: "EDUCATIONAL.SCHOOL_DESC_SUB",
    },
  ];

  const schoolSchema = ({
    hideRequestedLoanAmount = true,
    tenureOptions = [],
  }) => [
    {
      type: "number",
      key: "request_amount",
      label: "Requested_loan_amount_",
      span: 24,
      required: !hideRequestedLoanAmount,
      disabled: hideRequestedLoanAmount,
      pattern: "^[0-9]*$",
      validation: Yup.number()
        .required("CANNOT_BE_EMPTY")
        .min(3500, "MUST_BE_ATLEAST_3500")
        .max(500000, "CANNOT_EXCEED_500000"),
      // validation: Yup.number()
      //     .when('productId', (productId, schema) => {
      //         // const parsed = productId[0] ? JSON.parse(productId[0]) : null;
      //         // if (parsed && parsed.PRODUCTID === 328) {
      //         return schema.required("CANNOT_BE_EMPTY")
      //             .integer("MUST_BE_INTEGER")
      //             .min(2000, "MUST_BE_ATLEAST_2000")
      //             .max(50000, "CANNOT_EXCEED_50000")
      //         // }
      //         // return schema.notRequired();
      //     }),
    },
    {
      type: "select",
      key: "tenure",
      label: "Tenure_",
      required: true,
      options: tenureOptions,
      // value: 4,
      span: 12,
      validation: Yup.string().required("CANNOT_BE_EMPTY"),
      // .when('request_amount', (request_amount, schema) => {
      //   if (request_amount >= 2500 && request_amount <= 5000) {
      //     return schema.test(
      //       'max1',
      //       'MAX_12_MONTHS',
      //       value => { return parseInt(value, 10) <= 4 }
      //     );
      //   } else if (request_amount >= 5001 && request_amount <= 20000) {
      //     return schema.test(
      //       'max2',
      //       'MAX_36_MONTHS',
      //       value => parseInt(value, 10) <= 8
      //     );
      //   } else if (request_amount >= 20001) {
      //     return schema.test(
      //       'max3',
      //       'MAX_60_MONTHS',
      //       value => parseInt(value, 10) <= 12
      //     );
      //   }
      //   return schema; // default case if none of the conditions are met
      // }),
    },
    {
      type: "number",
      key: "salesRef",
      label: "ReferenceID",
      span: 12,
      required: false,
      max: 10,
      min: 8,
      maxLength: 10,
      minLength: 8,
      validation: Yup.string().matches(
        /^\d{8,10}$/,
        "MUST_BE_BETWEEN_8_AND_10_DIGITS"
      ),
    },
  ];

  const TenureUpdater = (props) => {
    const tenureOpt = useMemo(() => {
      // const amount = props.values?.request_amount;
      // if (amount <= 3500 && amount >= 5000) return [{ value: '6', label: '6' }, { value: '12', label: '12' }];
      // if (amount >= 10001 && amount <= 25000) return [{ value: '6', label: '6' }, { value: '12', label: '12' }, { value: '24', label: '24' }, { value: '36', label: '36' }];
      // if (amount >= 25001 && amount <= 500000) return [{ value: '6', label: '6' }, { value: '12', label: '12' }, { value: '24', label: '24' }, { value: '36', label: '36' }, { value: '48', label: '48' }, { value: '60', label: '60' }];

      if (id == "4")
        return [
          { value: "6", label: "6" },
          { value: "10", label: "10" },
        ];
      if (id == "8")
        return [
          { value: "6", label: "6" },
          { value: "8", label: "8" },
          { value: "10", label: "10" },
        ];
      if (id == "10")
        return [
          { value: "6", label: "6" },
          { value: "10", label: "10" },
        ];
      if (id == "11")
        return [
          { value: "6", label: "6" },
          { value: "8", label: "8" },
          { value: "10", label: "10" },
          { value: "12", label: "12" },
        ];
      else return [{ value: "10", label: "10" }];
    }, [props.values?.request_amount]);

    let tenureSelectionCheck = tenureOpt.find(
      (opt) => opt.value === props.values?.tenure
    );
    if (tenureSelectionCheck === undefined && props.values?.tenure !== "") {
      props.setValues((prev) => ({
        ...prev,
        tenure: "",
      }));
    }

    setTenureOptions(tenureOpt);

    return null; // This component doesn't render anything directly
  };

    // ========== V1 FUNCTIONS (KEPT FOR BACKWARDS COMPATIBILITY) ==========
  const SchoolAppSubmitV1 = async (values, appId, idbUserId) => {
    values.productId = '330' //murhaba
    values.subproductId = '367'
    values.applStatus = 'S' //submitted

        switch (id) {
            case "1":
                values.dealerId = '1505'    // ALNUBALAA EST
                break;
            case "2":
                values.dealerId = '1506'    // DIGITAL CULTURE SCHOOLS - AL-MUNSIYAH
                break;
            case "3":
                values.dealerId = '1507'    // DIGITAL CULTURE SCHOOLS - IRQAH
                break;
            case "4":
                values.dealerId = '1504'    // MINNHA PLATFORM
                break;
            case "5":
                values.dealerId = '1508'    // Interlude
                break;
            case "6":
                values.dealerId = '1509'    // ACHET
                break;
            case "7":
                values.dealerId = '1510'    // ADCCC
                break;
            case "8":
                values.dealerId = '1512'    // Sada Al-Abdaa Educational
                break;
            case "9":
                values.dealerId = '1511'    // YaSchools
                break;
            case "10":
                values.dealerId = '1513'    // AL Mashael School
                break;
            case "11":
                values.dealerId = '1514'    // Almoosa College of health Science
                break;
            default:
                return
        }

    const response = await updateApplicationDetails({
      appId: appId,
      userWebId: idbUserId,
      source: 'WEB',
      details: values,
    });
        if (response.error) {
      console.log("Error in update application", response.error);
      toast.error("Error in creating application");
      setIsCreating(false);
      return
    }
    if (response.data) {
      toast.success("Application Created Successfully");
      setIsCreating(false);
      navigate(`/${routes.APP_ROOT}/${routes.CREATE_REQUEST}/${routes.CREATE_REQUEST_SUCCESS}/${appId}/1`, { replace: true });
    }
  }
  ;

  const SchoolAppCreateV1 = async (values) => {
    try {
      setIsCreating(true);
      const user = getUser();

      if (!user) {
        setIsCreating(false);
        return;
      }

      const res = await createNewApp({
        id: String(user?.IDB_USR_ID),
        idNumber: String(user?.USER_ID),
        idType: String(user?.USER_ID)[0] === "1" ? "NID" : "Q",
      }).unwrap();
      if (res?.query) {
        handleUploadDocumentsV1(fileList, res?.query);
        await SchoolAppSubmitV1(values, res?.query, String(user?.IDB_USR_ID));
      } else {
        setIsCreating(false);
      }
    } catch (ex) {
      console.log("Error in create application", ex);
      const errorCode = ex?.data?.error?.code;
      if (errorCode === 'ACTIVE_APPLICATION' || errorCode === 'APPLICATION_EXISTS') {
        toast.error(translate('ACTIVE_APPLICATION'));
      } else {
        toast.error(ex?.data?.error?.message || "Error in creating application");
      }
      setIsCreating(false);
    }
  }

  const handleUploadDocumentsV1 = async (files, appId) => {
    setIsUploading(true);
    let updatedDocumentDetails = [...files];
    let allSuccess = true;
    await Promise.all(
      fileList.map(async (file, index) => {
        const formData = new FormData();
        formData.append("document", file);
        formData.append("appId", appId);
        const data = JSON.parse(localStorage.getItem("@@TAMWEEL_USER"));

                try {
                    await axios.post(`${env.API_ENDPOINT}app/upload-document`, formData, {
                        headers: {
                            Authorization: `Bearer ${data.token}`,
                        },
                    });
                    updatedDocumentDetails.splice(index, 1);
                } catch (err) {
                    allSuccess = false;
                    toast.error("Failed to upload file.");
                }
            })
        )
        setIsUploading(false)
    }

    // ========== V2 FUNCTIONS (ACTIVE) ==========
    const schoolAppSubmitV2 = async (applicationId) => {
        try {
            console.log('> Submitting school application V2:', applicationId);

            const response = await updateApplicationDetailsV2({
                applicationId: applicationId
            });

            if (response.error) {
                console.error('> Error submitting school application:', response.error);
                toast.error("Error in submitting application");
                setIsCreating(false);
                return false;
            }

            if (response.data) {
                console.log('> School application submitted successfully');
                toast.success("Application Created Successfully");
                setIsCreating(false);
                navigate(`/${routes.APP_ROOT}/${routes.CREATE_REQUEST}/${routes.CREATE_REQUEST_SUCCESS}/${applicationId}/1`, { replace: true });
                return true;
            }
        } catch (error) {
            console.error('> Exception in schoolAppSubmitV2:', error);
            toast.error("Error in submitting application");
            setIsCreating(false);
            return false;
        }
    };

    const schoolAppCreateV2 = async (values) => {
        try {
            setIsCreating(true);
            const user = getUser();

            if (!user) {
                setIsCreating(false);
                return;
            }

            console.log('> Creating school application V2 with values:', values);

            let dealerId = null;
            
            switch (id) {
                case "1":
                    dealerId = '100878'    // ALNUBALAA EST
                    break;
                case "2":
                    dealerId = '101158'    // DIGITAL CULTURE SCHOOLS - AL-MUNSIYAH
                    break;
                case "3":
                    dealerId = '101159'    // DIGITAL CULTURE SCHOOLS - IRQAH
                    break;
                case "4":
                    dealerId = '101160'    // MINNHA PLATFORM
                    break;
                case "5":
                    dealerId = '101161'    // Interlude (interload in LOV table)
                    break;
                case "6":
                    dealerId = '100880'    // ACHET
                    break;
                case "7":
                    dealerId = '100881'    // ADCCC
                    break;
                case "8":
                    dealerId = '100875'    // Sada Al-Abdaa Educational
                    break;
                case "9":
                    dealerId = '100879'    // YaSchools
                    break;
                case "10":
                    dealerId = '100876'    // AL Mashael School
                    break;
                case "11":
                    dealerId = '101164'    // Almoosa College of health Science
                    break;
                default:
                    console.error('> Invalid school id:', id);
                    toast.error("Invalid school selection");
                    setIsCreating(false);
                    return;
            }

            console.log('> Selected dealerId for school:', dealerId);

            // Step 1: Create application via V2 API
            const res = await createNewMurabahaApp({
                productRef: "SMB.TA.PERSONAL.FINANCE.EDU",
                productGroupRef: "SMB.TA.PERSONAL.FINANCE.EDU",
                productName: "APL-EDU",
                productSubType: "EDUCATIONFEES",
                idType: String(user?.USER_ID)[0] === "1" ? "NATIONAL.ID" : "IQAMA.ID",
                idNumber: String(user?.USER_ID),
                userWebId: Number(user?.IDB_USR_ID),
                source: "Web",
                details: {
                    request_amount: values.request_amount,
                    tenure: values.tenure,
                    salesRef: values.salesRef || null,
                    dealerId: dealerId
                }
            }).unwrap();

            if (res?.data?.applicationId) {
                const appId = res.data.applicationId;
                console.log('> School application created with ID:', appId);

                // Step 2: Upload documents
                await uploadV2Documents(appId);

                // Step 3: Show IVR verification modal instead of submitting
                setIvrApplicationId(appId);
                setIsIvrModalVisible(true);
                setIsCreating(false);
            } else {
                toast.error("Failed to create application");
                setIsCreating(false);
            }
        } catch (ex) {
            console.error("Error in create school application:", ex);
            const errorCode = ex?.data?.error?.code;
            if (errorCode === 'ACTIVE_APPLICATION' || errorCode === 'APPLICATION_EXISTS') {
                toast.error(translate('ACTIVE_APPLICATION'));
            } else {
                toast.error(ex?.data?.error?.message || "Error in creating application");
            }
            setIsCreating(false);
        }
    };

    // V2 Document upload function
    const uploadV2Documents = async (appId) => {
        if (!fileList || fileList.length === 0) {
            console.log('> No documents to upload');
            return;
        }

        console.log('> Uploading documents for school app:', appId);
        setIsUploading(true);

        try {
            await Promise.all(
                fileList.map(async (file) => {
                    return uploadSingleDocument(file, 'OTHERS', appId);
                })
            );
            console.log('> All school documents uploaded successfully');
        } catch (error) {
            console.error('> Error uploading school documents:', error);
            toast.error("Some documents failed to upload");
        } finally {
            setIsUploading(false);
        }
    };

    // Helper function to upload a single document
    const uploadSingleDocument = async (file, documentType, appId) => {
        const formData = new FormData();
        formData.append("document", file.originFileObj || file);
        formData.append("appId", appId);
        formData.append("docType", documentType);

        const data = JSON.parse(localStorage.getItem("@@TAMWEEL_USER"));

        try {
            await axios.post(`${env.API_ENDPOINT_V2}app/upload-document`, formData, {
                headers: {
                    Authorization: `Bearer ${data.token}`,
                    "Content-Type": "multipart/form-data",
                },
            });
            console.log(`> Document uploaded successfully: ${file.name}`);
            return true;
        } catch (err) {
            console.error(`> Failed to upload document: ${file.name}`, err);
            throw err;
        }
    };

  const beforeUpload = (file) => {
    const isJpgOrPngOrPdf =
      file.type === "image/jpeg" ||
      file.type === "image/png" ||
      file.type === "image/jpg" ||
      file.type === "application/pdf";
    if (!isJpgOrPngOrPdf) {
      toast.error(translate("SETTINGS.ERROR_FILE_TYPE"));
      return true;
    }

    const isLt3M = file.size / 1024 / 1024 < 3;
    if (!isLt3M) {
      toast.error(translate("SETTINGS.ERROR_FILE_SIZE_3MB"));
      return true;
    }

    const fileName = file.name;
    const multipleExtensionsPattern = /(\.[^.\s]{2,4}){2,}$/;
    if (multipleExtensionsPattern.test(fileName)) {
      toast.error(translate("SETTINGS.ERROR_FILE_MULTIPLE_EXT"));
      return true;
    }
    const invalidFileNamePattern = /^[^.]+\.[^.]+\..+\.[^.]+$/;

    if (invalidFileNamePattern.test(fileName)) {
      toast.error(translate("SETTINGS.ERROR_FILE_MULTIPLE_EXT"));
      return true;
    }

    if (fileName.toLowerCase().includes("contract")) {
      toast.error(translate("SETTINGS.ERROR_FILE_NAME_CONTRACT"));
      return true;
    }
    setUploadFile(file);
    return false;
  };

  const validateFile = (file) => {
        // Check for duplicate files first
        if (isDuplicateFileName(file.name)) {
            toast.error(
                `${translate("SETTINGS.ERROR_FILE_DUPLICATE")} / لقد تم تحديد هذا الملف بالفعل`
            );
            return false;
        }

    const isValidType =
      file.type === "image/jpeg" ||
      file.type === "image/png" ||
      file.type === "image/jpg" ||
      file.type === "application/pdf";

    if (!isValidType) {
      return false;
    }

    const isUnder3MB = file.size / 1024 / 1024 < 3;
    if (!isUnder3MB) {
      return false;
    }

    const fileName = file.name;
    const multipleExtensionsPattern = /(\.[^.\s]{2,4}){2,}$/;
    if (multipleExtensionsPattern.test(fileName)) {
      return false;
    }

    const invalidFileNamePattern = /^[^.]+\.[^.]+\..+\.[^.]+$/;
    if (invalidFileNamePattern.test(fileName)) {
      return false;
    }

    if (fileName.toLowerCase().includes("contract")) {
      return false;
    }

    return true; // File is valid
  };

    // Check if any individual upload is in progress
    const isAnyFileUploading = bankStatementUploading || paySlipUploading || otherDocumentsUploading;

    // Helper function to check for duplicate filenames
    const isDuplicateFileName = (fileName) => {
        const existingFiles = [
            selectedBankStatement,
            selectedPaySlip,
            selectedOtherDocuments
        ].filter(file => file !== null);

        return existingFiles.some(file => file.name === fileName);
    };

    // V2 Document selection component (before app creation)
    const V2DocumentSelectionComponent = ({ title, file, onSelect, onRemove }) => {
        const handleFileSelect = (info) => {
            const selectedFile = info.file;
            if (validateFile(selectedFile)) {
                onSelect(selectedFile);
            }
        };

        const uploadProps = {
            name: 'file',
            multiple: false,
            accept: "application/pdf",
            beforeUpload: () => false, // Prevent automatic upload
            onChange: handleFileSelect,
            showUploadList: false
        };

        return (
            <div className="border border-gray-200 border-dashed rounded-lg p-4 mb-4">
                <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                        <div className="w-8 h-8 bg-teal-100 rounded-lg flex items-center justify-center">
                            <UploadOutlined className="text-teal-600" />
                        </div>
                        <div>
                            <p className="font-medium text-gray-700">{translate(`CREATE_REQUEST.${title}`)}</p>
                            {file && (
                                <p className="text-sm text-gray-500">{file.name}</p>
                            )}
                        </div>
                    </div>

                    <div className="flex items-center gap-2">
                        {file ? (
                            <Button
                                onClick={onRemove}
                                className="text-red-500 border-red-500 hover:bg-red-50"
                                size="small"
                                icon={<DeleteOutlined />}
                            >
                                {translate("CREATE_REQUEST.REMOVE")}
                            </Button>
                        ) : (
                            <Upload {...uploadProps}>
                                <Button
                                    type="primary"
                                    className="bg-primary border-primary hover:bg-primary-dark"
                                >
                                    {translate("CREATE_REQUEST.SELECT_FILE")}
                                </Button>
                            </Upload>
                        )}
                    </div>
                </div>
            </div>
        );
    };

  const dragAndDropProps = {
    name: "file",
    multiple: true,
    maxCount: 3,
    accept: "image/png,image/jpeg,image/jpg,application/pdf",
    beforeUpload,
    fileList,
    onChange(info) {
      if (info.file.status === "error" || info.file.status === "removed") {
        setFileList((prev) => prev.filter((i) => i.uid !== info.file.uid));
        return;
      }
      const isValid = validateFile(info.file);
      if (isValid) {
        setFileList([...fileList, info.file]);
        // dispatch({ type: PATCH_DOCUMENT_DETAILS, payload: [...fileList, info.file] });
      }
    },
    onDrop(e) {
      setFileList([e.dataTransfer.files]);
    },
  };

  const handleRemove = (e) => {
    let updateFiles = fileList.filter((i) => i.uid !== e.uid);
    // console.log('hi', updateFiles)
    // dispatch({ type: PATCH_DOCUMENT_DETAILS, payload: updateFiles });
    setFileList((prev) => prev.filter((i) => i.uid !== e.uid));
    setUploadFile(null);
  };

  const schemaFields = useMemo(() => {
    let hideRequestedLoanAmount = false;

    return schoolSchema({
      hideRequestedLoanAmount: hideRequestedLoanAmount,
      tenureOptions,
    });
  }, [tenureOptions]);

  const schoolCards = (school) => {
    return (
      <div className="w-full max-w-[530px] max-h[250px] overflow-hidden">
        <div
          key={school.id}
          className="bg-[#E6F1F2] rounded-lg overflow-hidden flex flex-row  bg-[linear-gradient(to_left,#E1DBDB,#F9F9F9)]"
        >
          <div className="md:w-2/5 sm:w-2/5 w-1/2">
            <div className="flex justify-center items-center h-full w-full">
              <img
                src={school?.image}
                alt={school.id}
                className="w-[80%] max-h-full object-contain"
              />
            </div>
          </div>
          <div className="p-6 flex flex-col justify-between flex-1">
            <div>
              <h3 className="text-[#1F225B] text-xl md:text-2xl font-light mb-2">
                {school.title}
              </h3>
              <p className="text-[#8E9196] text-sm md:text-base mb-4">
                {translate(school.description)}
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderRequestedAmountNotice = (className = "") => (
    <div className={`bg-[#F4FAFB] p-5 ${className}`.trim()}>
      <p className="mb-2 text-start text-base font-medium text-[#2F2F2F] md:text-base">
        {translate("PRODUCTS.REQUESTED_AMOUNT_NOTICE_TITLE")}
      </p>
      <p className="text-start text-sm font-normal leading-6 text-[#2F2F2F] md:text-base">
        {translate("PRODUCTS.REQUESTED_AMOUNT_NOTICE_TEXT")}
      </p>
    </div>
  );

  const schoolCardDetails = (school) => {
    return (
      <div
        bordered={false}
        className="bg-transparent shadow-none rounded-none border-none outline-none"
        style={{
          width: "100%",
          maxWidth: "550px",
          // minHeight: "250px",
          boxShadow: "none", // Remove shadow
          border: "none", // Remove border
          borderRadius: "0", // Remove border-radius
          outline: "none",
          padding: "0",
          // direction: 'ltr'
        }}
      >
        <div className="my-5">
          <p className="text-[#878787] mt-3 text-base md:text-lg font-light text-start mb-2">
            {translate(school.subDescription)}
          </p>
        </div>

        <ul className="mt-5">
          {[
            translate("EDUCATIONAL.AUTO_PT1"),
            translate("EDUCATIONAL.AUTO_PT2"),
            translate("EDUCATIONAL.AUTO_PT3"),
            translate("EDUCATIONAL.AUTO_PT4"),
            translate("EDUCATIONAL.AUTO_PT5"),
            translate("EDUCATIONAL.AUTO_PT6"),
            translate("EDUCATIONAL.AUTO_PT7"),
            translate("EDUCATIONAL.AUTO_PT8"),
          ].map((text, index) => (
            <li className="flex mb-4 gap-2" key={index}>
              <span className="flex-shrink-0">
                <img src={Arrow} alt="checkmark" className="w-6 h-6" />
              </span>
              <span className="text-sm break-words">{text}</span>
            </li>
          ))}
        </ul>

        {renderRequestedAmountNotice("mt-6 hidden md:block")}
      </div>
    );
  };

  return (
    <div className="rounded-xl mb-4 px-4 py-4 bg-white shadow-lg">
      <SalaryEligibilityGate productCode="MUR" />
      <div className="p-5">
        {/* <Button onClick={() => navigate(-1)}>{translate("Back")}</Button> */}
        <BackButton onClick={() => navigate(-1)} />

        <Row gutter={[16, 16]} className="pt-4">
          {/* Card Section */}
          <Col xs={24} md={10}>
            {0 < Number(id) <= 3 && schoolCards(schoolDetails[Number(id) - 1])}
            {0 < Number(id) <= 3 &&
              schoolCardDetails(schoolDetails[Number(id) - 1])}
          </Col>

                    {/* Form Section */}
                    <Col xs={24} md={14}>
                        <Formik
                            innerRef={formikRef}
                            validateOnChange={true}
                            validateOnMount={true}
                            initialValues={buildInitialValues(schemaFields)}
                            validationSchema={buildValidationSchema(schemaFields)}
                            onSubmit={(values) => schoolAppCreateV2(values)}
                        >
                            {(props) => (
                                <Form onFinish={() => props.handleSubmit()}>
                                    {TenureUpdater(props)}
                                    <Title level={5} style={{ color: '#030438' }}>
                                        {translate('VOUCHERS.FILL_FORM')}
                                    </Title>
                                    <div>
                                        <FormDrawer schema={{ fields: schemaFields }} />
                                    </div>
                                    <div className="my-4">
                                        <label className="block text-gray-600 font-medium mb-2">
                                            {translate("SETTINGS.DOCUMENT_DES_V2")}
                                        </label>

                                        <V2DocumentSelectionComponent
                                            title="BANK_STATEMENT"
                                            file={selectedBankStatement}
                                            onSelect={setSelectedBankStatement}
                                            onRemove={() => setSelectedBankStatement(null)}
                                        />

                                        <V2DocumentSelectionComponent
                                            title="PAY_SLIP"
                                            file={selectedPaySlip}
                                            onSelect={setSelectedPaySlip}
                                            onRemove={() => setSelectedPaySlip(null)}
                                        />

                                        <V2DocumentSelectionComponent
                                            title="OTHER_DOCUMENTS"
                                            file={selectedOtherDocuments}
                                            onSelect={setSelectedOtherDocuments}
                                            onRemove={() => setSelectedOtherDocuments(null)}
                                        />
                                    </div>

                                      {renderRequestedAmountNotice("mt-6 md:hidden")}

                                    <div className="flex justify-end mt-8">

                                        <Button
                                            disabled={!props.isValid || isCreating || isLoading || isAnyFileUploading}
                                            type="primary"
                                            htmlType="submit"
                                            className="mt-4 bg-primary border-none text-white font-semibold p-6 w-40"
                                        >
                                            {(isLoading || isAnyFileUploading || isCreating) ? <LoadingOutlined /> :
                                                translate("APPLY")}
                                        </Button>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </Col>
                </Row>
            </div>

            {/* IVR Verification Modal */}
            <Modal
                open={isIvrModalVisible}
                footer={null}
                closable={true}
                closeIcon={<CloseOutlined style={{ fontSize: '18px', color: '#000' }} />}
                onCancel={() => {
                    setIsIvrModalVisible(false);
                    // Navigate to success page when modal is closed
                    if (ivrApplicationId) {
                        navigate(`/${routes.APP_ROOT}/${routes.CREATE_REQUEST}/${routes.CREATE_REQUEST_SUCCESS}/${ivrApplicationId}/2`, { replace: true });
                    }
                }}
                centered
                width={500}
                bodyStyle={{ padding: '40px' }}
            >
                <div className="flex flex-col items-center text-center">
                    <img src={ivrPending} alt="IVR Verification" className="w-64 h-64 mb-6" />
                    <h2 className="text-2xl font-semibold mb-4 text-gray-800">
                        {translate("CREATE_REQUEST.IVR_VERIFICATION_TITLE")}
                    </h2>
                    <p className="text-gray-600 text-base leading-relaxed">
                        {translate("CREATE_REQUEST.IVR_VERIFICATION_MESSAGE")}
                    </p>
                    <Button
                        type="primary"
                        className="mt-6 bg-primary border-none text-white font-semibold px-16 py-5 rounded-3xl hover:bg-secondary"  
                        onClick={() => {
                            setIsIvrModalVisible(false);
                            // Navigate to success page when button is clicked
                            if (ivrApplicationId) {
                                navigate(`/${routes.APP_ROOT}/${routes.CREATE_REQUEST}/${routes.CREATE_REQUEST_SUCCESS}/${ivrApplicationId}/2`, { replace: true });
                            }
                        }}
                    >
                        {translate("CREATE_REQUEST.CONTINUE")}
                    </Button>
                </div>
            </Modal>
        </div>

  )
}

export default SchoolProducts;
